import ParaModel from 'src/paraphraser/handlers/ParaModel';
import { reQuillArticle, setFocusedParaphraser } from './controlActions';
import { showTncDialog } from './paraModelActions';
import { showRequillLabelTooltip } from './systemActions';
import { NON_PREMIUM_MODE_STRENGTH } from 'src/paraphraser/constants';

/**
 * Paraphrase/rephrase article action
 * @param sourceFn This will determine if we want to change the beam or apply changes to same beam.
 * redo function will change the beams while redoWF will make changes on same beam.
 */
export const paraphraseArticle =
  (sourceFn: 'redo' | 'redoWF' = 'redo') =>
  (dispatch: any, getState: any) => {
    const paraModelState = getState()?.pphr;
    const user = getState()?.user;
    const strength = paraModelState?.strength;
    // let showDialog = ParaModel.showPremiumModesTncDialog(paraModelState, user);
    // if (showDialog) {
    //   dispatch(showTncDialog(true));
    //   return;
    // }
    if (!user?.premium && user?.isAuthenticated) {
      if (NON_PREMIUM_MODE_STRENGTH.indexOf(strength) !== -1) dispatch(reQuillArticle(sourceFn));
    } else {
      dispatch(reQuillArticle(sourceFn));
    }
    // dispatch(reQuillArticle(sourceFn));
  };

export const selectNextParaphrase = () => (dispatch: any, getState: any) => {
  var curI = ParaModel.paraphrasers.indexOf(ParaModel.focusedParaphraser);
  if (curI === -1) return;
  var paraphrasers = ParaModel.paraphrasers;
  var newSent = paraphrasers[(curI + 1) % paraphrasers.length];
  if (newSent) {
    dispatch(setFocusedParaphraser(newSent));
    // dispatch(showRequillLabelTooltip());
  }
};

export const selectPrevParaphrase = () => (dispatch: any, getState: any) => {
  var index = ParaModel.paraphrasers.indexOf(ParaModel.focusedParaphraser);
  if (index == -1) return;
  index -= 1;
  if (index < 0) {
    index = ParaModel.paraphrasers.length - 1;
  }
  var paraphrasers = ParaModel.paraphrasers;
  var newSent = paraphrasers[index % paraphrasers.length];
  if (newSent) {
    dispatch(setFocusedParaphraser(newSent));
    // dispatch(showRequillLabelTooltip());
  }
};
